import HTTP from "../HTTP";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async index(page) {
    try {
      let results = await HTTP.normal.get(`/states?page%5Bnumber%5D=${page}`);
      return {
        data: results.data.data,
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os estados!";
    }
  },

  async searchByName(state_name) {
    try {
      let results = await HTTP.normal.get(
        `/states?filter[display_name]=${state_name}&filter[active]=true`
      );

      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao listar os estados!";
    }
  },

  async all() {
    try {
      let results = await HTTP.normal.get(`/states?filter[active]=true`);
      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao listar todos os estados!";
    }
  },

  async create(payload) {
    let data = {
      type: "states",
      display_name: payload.display_name,
      code: payload.code,
      country: {
        type: "countries",
        id: payload.country_id
      },
      relationshipNames: ["country"]
    };

    data = dataFormatter.serialize({
      stuff: data
    });

    try {
      await HTTP.normal.post("/states", data);
    } catch (e) {
      var error = [];

      e.response.data.errors.map(el => {
        if (el.title === "has already been taken") {
          error.push({
            field: el.detail.split(" ")[0],
            msg: "já está sendo usado"
          });
        }
      });

      throw error;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/states.js